import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  IconButton,
} from "@mui/material";
import { useState } from "react";
import { Link, useLoaderData, useNavigate } from "react-router-dom";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import SyncIcon from "@mui/icons-material/Sync";

import useCheckPermission from "../../../../common/hooks/useCheckPermission";
import useGetPageInfo from "../../../../common/hooks/useGetPageInfo";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import EnhancedTable from "../../../../components/shared/table";

const SupervisorContractorProjectContractPage = () => {
  const pageInfo = useGetPageInfo();

  const dataList = useLoaderData("root");

  let navigate = useNavigate();
  const [deleteConfirm, setDeleteConfirm] = useState({
    open: false,
    data: {},
    cascadeDelete: false,
  });
  const headCells = [
    {
      id: "updateOn",
      label: "تاریخ",
      type: "date",
    },

    {
      id: "title",
      label: "شماره قرارداد",
    },

    {
      id: "projectContractStatus",
      label: "وضعیت قرارداد",
    },
    {
      id: "price",
      label: "مبلغ قرارداد",
    },

    {
      id: "startDateTime",
      label: "تاریخ شروع",
      type: "date",
    },
    {
      id: "endDateTime",
      label: "تاریخ پایان",
      type: "date",
    },
  ];

  const onEditClicked = (row) => {
    navigate(`${row.id}`);
  };

  const onFetchData = () => {
    navigate();
  };

  const getRowStatus = (row) => {
    switch (row.requestConfirm) {
      case "NotChecked":
        return "gray";
      case "Canceled":
        return "danger";
      case "InProcess":
        return "primary";
      case "Completed":
        return "success";
      default:
        return "warning";
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={pageInfo.title}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                {useCheckPermission("create") && (
                  <Link to={"create"}>
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<AddIcon />}
                    >
                      ایجاد
                    </Button>
                  </Link>
                )}

                <Divider
                  orientation="vertical"
                  variant="middle"
                  flexItem
                  sx={{ mx: 1 }}
                />

                <IconButton
                  variant="text"
                  color="primary"
                  onClick={onFetchData}
                >
                  <SyncIcon />
                </IconButton>
              </Box>
            }
          />

          <CardContent>
            <Grid container>
              <Grid item xs={12} md={12}>
                <EnhancedTable
                  rowKey={"id"}
                  rows={dataList}
                  headCells={headCells}
                  pageSize={100}
                  actions={[
                    {
                      icon: useCheckPermission("edit") ? (
                        <EditIcon sx={{ width: "1rem", height: "1rem" }} />
                      ) : null,
                      onClick: onEditClicked,
                      color: "primary",
                    },
                  ]}
                  getRowStatus={getRowStatus}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default SupervisorContractorProjectContractPage;
